import React from 'react';

import { GetFluxNextExecutionTimeResponseDtoFluxTypeEnum } from 'lib_api/lib/api/gen';

import { FluxDisplayName } from 'enums/flux/FluxDisplayName';

import DashboardFluxAlienation from '../shared/components/DashboardFluxAlienation';

import { useSearchFluxLieuxDepot } from './utils';

function DashboardSynchroLieuxDepot() {
  return (
    <DashboardFluxAlienation
      useSearchFluxs={useSearchFluxLieuxDepot}
      buildSpecificTableColumns={() => []}
      tableTitle={FluxDisplayName.ALIENATION_FOURRIERE}
      fluxType={
        GetFluxNextExecutionTimeResponseDtoFluxTypeEnum.ALIENATION_LIEU_DEPOT
      }
      keyPagination={'paginationFluxAlienationLieuxDepots'}
    />
  );
}

export default DashboardSynchroLieuxDepot;
